// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__+WGsh","titleTag":"Tag_titleTag__4kOPg","tagSelected":"Tag_tagSelected__eJsJ1"};